import { ReactElement } from 'react';
import { formatDate } from '../../../../utils';
import { ITableLogsData } from '../logs-list.models';

export const EventDateCell = (data: ITableLogsData): ReactElement => (
  <div className="logs-table__event-date">
    {formatDate(data.event_date_time, 'dd.MM.yyyy, k:mm')}
  </div>
);
